// import { useTheme } from '@pata-app/themes';
// import { WidthContainer } from '@pata-app/ui-document';
// import { Image } from '@pata-app/ui-media';
// import React from 'react';
// import { getEnv } from '../../lib/utils/getEnv';
// import ReviewScore from '../review-score/review-score';
// import SectionContainer from '../sectionContainer/sectionContainer';
// import { TestimoninalTile } from '../testimoninalTile/testimoninalTile';
// import { FeatureTilesContainer } from '../testimoninalTile/testimoninalTile.styled';
// import { TextWithHighlight } from '../textWithHighlight/textWithHighlight';
// import { TestimoninalContent } from './testimoninal.styled';
// const TestimoninalTitle = () => {
//   return (
//     <TextWithHighlight>
//       <h2>
//         Why <span>pet care businesses </span>
//         trust Pata booking software
//       </h2>
//     </TextWithHighlight>
//   );
// };
// const TestimoninalSubTitle = () => {
//   return (
//     <p>
//       We think our booking platform can make a world of difference, but don't just take our word for it. Here's why pet
//       groomers, dog trainers, dog walkers and other UK professionals love using Pata to manage bookings, reduce admin
//       and grow their pet care business.
//     </p>
//   );
// };
// export function Testimoninal({ indexes, title: Title = TestimoninalTitle, subTitle: SubTitle = TestimoninalSubTitle }) {
//   const theme = useTheme();
//   const { VITE_CDN_BASE_URL } = getEnv();
//   return (
//     <WidthContainer noBackground>
//       <SectionContainer title={Title} subTitle={SubTitle}>
//         <FeatureTilesContainer>
//           {indexes.includes(0) && (
//             <TestimoninalTile alignment="right" color={theme.core.colors.secondary.yellow.medium}>
//               <TestimoninalContent>
//                 <Image
//                   alt="Logo of Mia's Paw, a dog grooming business using Pata booking software"
//                   src={`${VITE_CDN_BASE_URL}/images/image-mias-paws-logo.webp`}
//                 />
//                 <div>
//                   <h3>Amazing for my business!</h3>
//                   <ReviewScore rating={5} />
//                   <p>
//                     "My favourite feature is that clients can leave reviews about my services. The platform is very easy
//                     to use, and the team is always there - you never feel like you’re left on your own. Pata has been
//                     amazing for my business!"
//                   </p>
//                 </div>
//                 <p>Amanda Coverdale, Pet Groomer at Mia's Paw Spa - Gateshead</p>
//               </TestimoninalContent>
//             </TestimoninalTile>
//           )}
//           {indexes.includes(1) && (
//             <TestimoninalTile alignment="right" color={theme.core.colors.primary.green.medium}>
//               <TestimoninalContent>
//                 <Image
//                   alt="Logo of Whitegates Grooming Palour, a dog grooming business using Pata booking software"
//                   src={`${VITE_CDN_BASE_URL}/images/image-whitegates-grooming-logo.png`}
//                 />
//                 <div>
//                   <h3>It's simple, quick & just works!</h3>
//                   <ReviewScore rating={5} />
//                   <p>
//                     "Pata’s great for managing new clients, and super handy for regulars when I can’t get to the phone.
//                     I love the online booking option: It’s simple, quick, and it just works. Huge time-saver for both
//                     myself and my customers!"
//                   </p>
//                 </div>
//                 <p>Leigh Butcher, Pet Groomer at Whitegates Grooming Parlour - Colchester</p>
//               </TestimoninalContent>
//             </TestimoninalTile>
//           )}
//           {indexes.includes(2) && (
//             <TestimoninalTile alignment="right" color={theme.core.colors.primary.blue.medium}>
//               <TestimoninalContent>
//                 <Image
//                   alt="Logo of Talk of the Dog, a Dog Behaviourist using Pata booking software"
//                   src={`${VITE_CDN_BASE_URL}/images/image-talk-of-the-log-logo.webp`}
//                 />
//                 <div>
//                   <h3>Pata is brilliant! </h3>
//                   <ReviewScore rating={5} />
//                   <p>
//                     "Pata is brilliant because it’s so easy to set up and use! Everything is straightforward, and if you
//                     do need help, their team is just an email away."
//                   </p>
//                 </div>
//                 <p>Erik Prins, Dog Behaviourist at Talk Of The Dog - Atherstone</p>
//               </TestimoninalContent>
//             </TestimoninalTile>
//           )}
//         </FeatureTilesContainer>
//       </SectionContainer>
//     </WidthContainer>
//   );
// }
import { Image } from '@pata-app/ui-media';

import React from 'react';

import { getEnv } from '../../lib/utils/getEnv';
import ReviewScore from '../review-score/review-score';
import { SlideCarousel } from '../slideCarousel/slideCarousel';
import { TestimoninalTile } from '../testimoninalTile/testimoninalTile';
import { TestimoninalContent } from './testimoninal.styled';

const { VITE_CDN_BASE_URL } = getEnv();

export const testimonialOptions = {
  mias_paw_spa: (
    <TestimoninalContent>
      <Image
        alt="Logo of Mia's Paw, a dog grooming business using Pata booking software"
        src={`${VITE_CDN_BASE_URL}/images/image-mias-paws-logo.webp`}
      />
      <div>
        <h3>Amazing for my business!</h3>
        <ReviewScore rating={5} />
        <p>
          "My favourite feature is that clients can leave reviews about my services. The platform is very easy to use,
          and the team is always there - you never feel like you’re left on your own. Pata has been amazing for my
          business!"
        </p>
      </div>
      <p>Amanda Coverdale, Pet Groomer at Mia's Paw Spa - Gateshead</p>
    </TestimoninalContent>
  ),
  talk_of_the_dog: (
    <TestimoninalContent>
      <Image
        alt="Logo of Talk of the Dog, a Dog Behaviourist using Pata booking software"
        src={`${VITE_CDN_BASE_URL}/images/image-talk-of-the-log-logo.webp`}
      />
      <div>
        <h3>Pata is brilliant! </h3>
        <ReviewScore rating={5} />
        <p>
          "Pata is brilliant because it’s so easy to set up and use! Everything is straightforward, and if you do need
          help, their team is just an email away."
        </p>
      </div>
      <p>Erik Prins, Dog Behaviourist at Talk Of The Dog - Atherstone</p>
    </TestimoninalContent>
  ),
  whitegates_grooming: (
    <TestimoninalContent>
      <Image
        alt="Logo of Whitegates Grooming Palour, a dog grooming business using Pata booking software"
        src={`${VITE_CDN_BASE_URL}/images/image-whitegates-grooming-logo.png`}
      />
      <div>
        <h3>It's simple, quick & just works</h3>
        <ReviewScore rating={5} />
        <p>
          "Pata’s great for managing new clients, and super handy for regulars when I can’t get to the phone. I love the
          online booking option: It’s simple, quick, and it just works. Huge time-saver for both myself and my
          customers!"
        </p>
      </div>
      <p>Leigh Butcher, Pet Groomer at Whitegates Grooming Parlour - Colchester</p>
    </TestimoninalContent>
  ),
  pet_palace: (
    <TestimoninalContent>
      <Image
        alt="Logo of The Pet Palace, a dog, cat and small animal grooming business using Pata booking software"
        src={`${VITE_CDN_BASE_URL}/images/image-the-pet-palace-logo.jpg`}
      />
      <div>
        <h3>Pata is the best booking software by far!</h3>
        <ReviewScore rating={5} />
        <p>
          "Pata is the best booking software by far! Their platform is very easy to navigate, both for ourselves and our
          clients, making online bookings a breeze. It’s also budget-friendly (subscription-free!), so look no further
          than Pata’s expert team who are always on hand to help."
        </p>
      </div>
      <p>Alice Cassell, Pet Groomer at The Pet Palace - Birmingham</p>
    </TestimoninalContent>
  ),
  pawfect_place: (
    <TestimoninalContent>
      <Image
        alt="Logo of Pawfect Place, a dog grooming business using Pata booking software"
        src={`${VITE_CDN_BASE_URL}/images/image-pawfect-place-logo.jpeg`}
      />
      <div>
        <h3>Change to Pata and watch your business thrive</h3>
        <ReviewScore rating={5} />
        <p>
          "Switching to Pata was so quick, and my clients find it much easier to use than my previous beauty system —
          especially when it comes to booking appointments. Their platform is tailored to the pet care industry and the
          team is so supportive. Change to Pata and watch your business thrive!"
        </p>
      </div>
      <p>Kate Dolan, Dog Groomer at Pawfect Place - Sunderland</p>
    </TestimoninalContent>
  ),
  groomed_by_nic: (
    <TestimoninalContent>
      <Image
        alt="Logo of Groomed by Nic Dog Grooming, a dog grooming business using Pata booking software"
        src={`${VITE_CDN_BASE_URL}/images/image-grooming-by-nic-logo.jpg`}
      />
      <div>
        <h3>I have a personal life again!</h3>
        <ReviewScore rating={5} />
        <p>
          "I thought a free booking service was too good to be true, especially when it includes appointment reminders.
          But Pata is intuitive, keeps track of admin, and has allowed me to put work boundaries in place so I have a
          personal life again! It’s very good at tailoring to my needs and is obviously suitable for all pet services,
          not just grooming."
        </p>
      </div>
      <p>Nicola Armstrong, Dog Groomer at Groomed by Nic Dog Grooming - Brampton</p>
    </TestimoninalContent>
  ),
  canine_body_works: (
    <TestimoninalContent>
      <Image
        alt="Logo of Canine Bodywork Clinic, a dog hydrotherapist business using Pata booking software"
        src={`${VITE_CDN_BASE_URL}/images/image-canine-bodywork-clinic-logo.webp`}
      />
      <div>
        <h3>Pata has been a real game changer</h3>
        <ReviewScore rating={5} />
        <p>
          "Pata has been a real game changer for my hydrotherapy business! Detailed client information like medical
          history and behaviour can be viewed at a glance, and the appointment reminders have meant fewer no-shows.
          Plus, my clients love Pata too, and the customer service has been second to none!"
        </p>
      </div>
      <p>Claire McGurk, Canine Hydrotherapist at Canine Bodywork Clinic - Livingston</p>
    </TestimoninalContent>
  ),
};

export function Testimoninal({ testimonialConfig }) {
  return (
    <SlideCarousel
      slideConfig={testimonialConfig}
      slideComponent={(review, index) => <TestimoninalTile color={review?.color} children={review.children} />}
    />
  );
}
